var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack214({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.53,3.93H7.7a6.16,6.16,0,0,1,1.64.17,2.8,2.8,0,0,1,1.29.79,3.64,3.64,0,0,1,.82,1.39,6.23,6.23,0,0,1,.29,2,5.52,5.52,0,0,1-.27,1.83,3.68,3.68,0,0,1-.92,1.51,2.94,2.94,0,0,1-1.22.69,5.24,5.24,0,0,1-1.53.18H4.53ZM6.27,5.39v5.68H7.56a4.4,4.4,0,0,0,1-.08,1.65,1.65,0,0,0,.7-.35,1.85,1.85,0,0,0,.46-.83,6,6,0,0,0,.17-1.58A5.47,5.47,0,0,0,9.77,6.7a1.94,1.94,0,0,0-.5-.83,1.6,1.6,0,0,0-.8-.4,7.42,7.42,0,0,0-1.42-.08Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack214);
export default __webpack_public_path__ + "static/media/Symbolpack_2_14.282f8d9969d8a7872632acd0d9bfa956.svg";
export { ForwardRef as ReactComponent };